import React from 'react'
import Sidenav from './Navbar';
import Herosection from './Pages/Homepage/Herosection'
import Servicesection from './Pages/Homepage/Servicesection';
import FooterSection from './Pages/Homepage/Footer';
import Camerasection from './Pages/Homepage/Camerasection'
import Softwaresection from './Pages/Homepage/Softwaresection';

export default function Home(props) {

    

    return (
        <>

            <Sidenav navbar_title="DevComputers" />
           

            <Herosection/>

            {/* Hero section ends */}


            {/* SERVICE SECTION START */}

            <Servicesection/>

            {/* service section ends */}


            {/* CAMERAS SECTION  */}

            <Camerasection/>

            {/* SOFTWARE SECTION  */}

            <Softwaresection/>

            {/* {footer service} */}
            <FooterSection/>
           
        </>
    )
}
